import { tv } from 'tailwind-variants';

export default tv({
  base: `
    relative
    z-10

    order-1
    mt-4
    w-full

    duration-100
    ease-in
    will-change-transform

    md:mt-6
    md:translate-y-0

    lg:order-[0]
    lg:ml-8
    lg:mr-16
    lg:mt-0
    lg:flex-1
  `,
  slots: {
    form: 'w-full',
    overlay: `
      pointer-events-none

      absolute
      left-0

      right-0
      z-[1100000]

      h-[200vh]

      bg-gray-900/50
      opacity-0

      transition-opacity
      ease-in-out
    `,
    input: `
      text-base

      h-10

      border
      border-transparent

      bg-gray-100

      font-bold

      reset-search
      placeholder:text-gray-600

      hover:border-gray-300

      focus:border-gray-400
      focus:bg-white
      focus:ring-gray-200

      lg:h-12
      lg:text-lg
    `,
    panel: `
      pointer-events-none
      absolute
      left-0

      right-0
      z-[1200000]
      mx-auto

      flex
      h-auto
      max-h-[calc(100vh-120px)]

      w-full
      flex-col

      overflow-y-auto
      bg-white
      p-6

      text-neutral-900
      opacity-0

      shadow-sm

      transition-opacity
      duration-100

      ease-in-out

      md:mt-2
      md:translate-y-0
      md:overflow-hidden

      md:shadow-none
    `,
    grid: `
      mx-auto
      grid
      w-full
      grid-cols-1
      gap-y-4

      md:gap-x-4

      [&>[data-area="products"]]:[grid-area:products]
      [&>[data-area="recents"]]:[grid-area:recents]
      [&>[data-area="services"]]:[grid-area:services]
      [&>[data-area="suggestions"]]:[grid-area:suggestions]
    `,
    gridRecents: `
      pb-4
    `,
    gridProducts: `
      md:border-l
      md:border-gray-100

      md:px-5
      `,
    gridServices: `
      md:border-l
      md:border-gray-100

      md:px-5
      `,
    listSuggestions: `
      mt-4
      flex
      flex-wrap
      gap-2
    `,
    list: `
      mt-4
      grid
      gap-4
      break-all
    `,
    suggestion: `
      cursor-pointer

      [&[aria-selected='true']_a]:text-green-600
      [&[aria-selected='true']_span]:text-green-600

      [&_a]:transition-colors
      [&_a]:duration-100
      [&_a]:ease-in
      [&_a]:hover:text-green-600
      [&_span]:hover:text-green-600
    `,
    product: `
      group

      [&[aria-selected='true']_span:first-of-type]:text-green-600
      [&_span]:transition-colors
      [&_span]:duration-100
      [&_span]:ease-in
    `,
    picture: `
      h-11
      w-11

      shrink-0
      overflow-hidden

      rounded-md
      border
      border-gray-300

      [&_img]:h-full
      [&_img]:w-full
      [&_img]:bg-gray-100
      [&_img]:transition-transform
      [&_img]:duration-100
      [&_img]:ease-in

      group-hover:[&_img]:scale-110
      [&_svg]:h-full
      [&_svg]:w-full

      [&_svg]:bg-[#158110]
      group-hover:[&_svg]:scale-110
    `,
  },
  variants: {
    isOpen: {
      true: {
        base: `
          mt-0
          -translate-y-10
        `,
        overlay: `
          pointer-events-auto
          opacity-100
          delay-100
          duration-100
        `,
        panel: `
          pointer-events-auto
          mt-0
          -translate-y-10
          opacity-100
        `,
      },
      false: {
        overlay: `
          pointer-events-none
          opacity-0
          delay-0
          duration-0
        `,
        panel: `
          pointer-events-none
          opacity-0
        `,
      },
    },
    areas: {
      true: {
        grid: `
          [grid-template-areas:"recents"_"suggestions"_"products"_"services"]
          md:[grid-template-areas:"recents_products_services"_"suggestions_products_services"]
        `,
      },
      false: {
        grid: `
          [grid-template-areas:"suggestions"_"products"_"services"]
          md:[grid-template-areas:"suggestions_products_services"]
        `,
      },
    },
    hasServices: {
      true: {
        grid: `
          md:grid-cols-[1fr_1fr_1fr]
        `,
      },
      false: {
        grid: `
          md:grid-cols-[1fr_1fr]
        `,
      },
    },
    maxWidth: {
      '6xl': {
        grid: 'max-w-6xl',
      },
      '7xl': {
        grid: 'max-w-7xl',
      },
    },
  },
  compoundVariants: [
    {
      areas: true,
      hasServices: false,
      class: {
        grid: `
          [grid-template-areas:"recents"_"suggestions"_"products"]
          md:[grid-template-areas:"recents_products"_"suggestions_products"]
        `,
      },
    },
    {
      areas: false,
      hasServices: false,
      class: {
        grid: `
          [grid-template-areas:"suggestions"_"products"]
          md:[grid-template-areas:"suggestions_products"]
        `,
      },
    },
  ],
});
